module.exports = __webpack_public_path__ + "img/checked.6fcc1527.png";